<div class="footerNav innerContainer">
  <div *ngFor="let navigation of navigations" class="footerNav__block footerNav__block--desktop d-lg">
    <div class=" js-accordionContainer">
      <div class="footerNav__title js-accordionTitle">{{ navigation.title }}</div>
      <div class="footerNav__list js-accordionContent">
        <vc-ref
          *ngFor="let content of navigation.content"
          class="footerNav__listItem"
          [resource]="content.link"
          [anchor]="isAnchored(content)"
          >{{ content.name }}</vc-ref
        >
      </div>
    </div>
  </div>
  <vc-accordion class="footerNav__block footerNav__block--mobile d-lg-none">
    <vc-accordion-group
      *ngFor="let navigation of navigations; let i = index"
      class="footerNav__block"
      [index]="i + 1"
      (change)="toggleAccordionClass($event)"
      [class.open]="modifierClass === i + 1"
      [isOpen]="false"
    >
      <div class="accordion__title footerNav__title">{{ navigation.title }}</div>
      <div class="accordion__content">
        <vc-ref
          *ngFor="let content of navigation.content"
          class="footerNav__listItem"
          [resource]="content.link"
          [anchor]="isAnchored(content)"
          >{{ content.name }}</vc-ref
        >
      </div>
    </vc-accordion-group>
  </vc-accordion>
</div>
